module.exports = __webpack_public_path__ + "static/img/9.3a96d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/9.png
// module id = ec70
// module chunks = 0